import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbCardModule } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { AmplifyAuthService } from 'src/app/core/services/amplify-auth.service';
import { SpinnerComponent } from 'src/app/shared/ui/spinner/spinner.component';
import { ENVIRONMENT } from 'src/environments/environment';
import { SetIsLogedIn, SetUserGroups, SetUsername } from '../redux';

@Component({
  selector: 'app-okta-login',
  templateUrl: './okta-login.component.html',
  styleUrls: ['./okta-login.component.css'],
  imports: [SpinnerComponent, NbCardModule]
})
export class OktaLoginComponent implements OnInit {
  public environment = ENVIRONMENT.name;

  constructor(
    private store: Store,
    private router: Router,
    private amplifyAuthService: AmplifyAuthService
  ) {}
  public ngOnInit(): void {
    this.initializeUser();
  }

  private async initializeUser(): Promise<void> {
    try {
      const session = await this.amplifyAuthService.fetchAuthSession();
      if (!session.tokens?.idToken) {
        await this.redirectToLogin();
        return;
      }

      const payload = session.tokens.idToken.payload;
      const rawGroups = payload?.['custom:groups'];

      const groups = this.parseGroups(rawGroups);
      const email = typeof payload?.email === 'string' ? payload.email : '';

      this.store.dispatch([new SetUsername(email), new SetUserGroups(groups), new SetIsLogedIn(true)]);

      const returnUrl = sessionStorage.getItem('returnUrl');
      sessionStorage.removeItem('returnUrl');
      this.router.navigateByUrl(returnUrl || '/quick-start');
    } catch {
      await this.redirectToLogin();
    }
  }

  private async redirectToLogin(): Promise<void> {
    await this.amplifyAuthService.signInWithRedirect({
      provider: {
        custom: 'OKTA'
      }
    });
  }

  private parseGroups(value: unknown): string[] {
    if (typeof value !== 'string') {
      return [];
    }

    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}
